import { useGebruikerContext } from "Pages/Coordinator/Gebruikers/Context/GebruikerContext";
import { createContext, useContext, useState } from "react";
import { debounce } from "../../helpers";
import { toast } from "react-toastify";
import { useContractType, useUpdateInstellingenDetail } from "Api/Coordinator/Gebruikers/Common/Instellingen";

export const InstellingenContext = createContext();

export const useInstellingen = () => {
  const context = useContext(InstellingenContext);
  if (!context)
    throw new Error("useInstellingen must be used within <Instellingen.Provider>");
  return context;
};

export const InstelligenProvider = ({ children }) => {
  const { userDetails,currentUser, filterCommunity, updateDataHandler } =
    useGebruikerContext();

  const [errorField, setErrorField] = useState("");
  const [contractModal, setContractModal] = useState({ type: "add", state: false });

  const iAdminId = currentUser?.data?.closerId;
  const iCommunityId = filterCommunity?.[0]?.iCommunityId;

 const { data: contractTypes } = useContractType(iCommunityId, iAdminId);

  const contractList = contractTypes?.data || [];

  const { trigger: updateInstellingenDetail } =
    useUpdateInstellingenDetail();

	
	const callApi = (field, value, lockState = null) => {
		const data = {
			iAdminId: currentUser.data.clooserId,
			attr: field,
			[field]: field === "iContractTypeId" ? Number(value) : value,
			iCommunityId: Number(filterCommunity[0].iCommunityId),
		};
		if (field === "iContractTypeId") {
			const selectedContract = contractList?.find(
				(item) => item.iContractTypeId === Number(value)
			);
			data.iContractLogLabel = selectedContract
				? `${selectedContract.vContractTypeAbbr} - ${selectedContract.vContractTypeName}`
				: "";
		}
		if (lockState === true || lockState === false) {
			data.type = "settings_locked";
			data.lock = lockState ? 1 : 0;
		}
		updateInstellingenDetail({
			data,
		})
			.then((response) => {
				if (response.status) {
					updateDataHandler();
					return;
				}
				if (!response.data.success) {
					setErrorField(field);
					const errors = response.data[field];
					if (Array.isArray(errors)) {
						toast.error(errors.join(","));
					} else {
						toast.error(errors);
					}
				}
			})
			.catch((error) => {
				console.error("API error:", error);
			});
	};

	const debouncedApiCall = debounce(callApi, 1000);

	const handleFieldChange = (field, value, lockState = null) => {
		setErrorField("");
		debouncedApiCall(field, value, lockState);
	};

	return (
		<InstellingenContext.Provider
			value={{
				errorField,
				setErrorField,
				handleFieldChange,
				contractList,
				contractModal,
				setContractModal,
				userDetails,
				updateDataHandler,
				currentUser,
			}}
		>
			{children}
		</InstellingenContext.Provider>
	);
};
